import React, {useRef, useState} from 'react';
import Deleteable from '../deletable';

const {useDropTarget, useDragSource, useHover} = polyphony.hooks;
const {Image, Modal} = polyphony.components.generic;
const {Link: LinkIcon} = polyphony.icons;

const MMImage = ({index, image, images, backgroundColor='lightgray', setImages}) => {
    const [linkOpen, setLinkOpen] = useState(false);
    const {BaseMediaPicker:{openMediaPicker: openPicker}} = polyphony.components.backend;
    const replaceImage = newIm => {
        images[index] = newIm;
        setImages(images);
    };

    const remove = () => {
        images.splice(index, 1);
        setImages(images);
    };

    const open = () => openPicker(image, replaceImage, ['image'], false);

    const imgRef = useRef();
    const [{}, dragSource] = useDragSource({
        type: 'sic/footer-logos',
        data: {index},
        hoverImage: imgRef
    });

    const onLinkLogoClick = () => {
        setLinkOpen(!linkOpen);
    };

    const saveLink = e => {
        images[index] = {...image, sic_link: e.target.value};
        setImages(images);
    };

    return (
       <Deleteable className='draggable-image' upSvg={<LinkIcon />} onUp={onLinkLogoClick} data-index={index} ref={dragSource} onDelete={remove} style={{margin: 12.5, position: 'relative'}}>
           <a onClick={open} style={{cursor: 'pointer'}}>
               <Image ref={imgRef} preferredSize='thumbnail' media={image} width={66} height={66} style={{ objectFit: 'contain', borderRadius: 5,
    background: `linear-gradient(45deg, rgba(100, 100, 100, 0.0980392) 25%,
                                        transparent 25%,
                                        transparent 75%,
                                        rgba(100, 100, 100, 0.0980392) 75%,
                                        rgba(100, 100, 100, 0.0980392) 0),

                 linear-gradient(45deg, rgba(100, 100, 100, 0.0980392) 25%,
                                        transparent 25%,
                                        transparent 75%,
                                        rgba(100, 100, 100, 0.0980392) 75%,
                                        rgba(100, 100, 100, 0.0980392) 0),
                 ${backgroundColor}`,
    backgroundRepeat: 'repeat, repeat',
    backgroundPosition: '0px 0, 5px 5px',
    transformOrigin: '0 0 0',
    backgroundOrigin: 'padding-box, padding-box',
    backgroundClip: 'border-box, border-box',
    backgroundSize: '10px 10px, 10px 10px'
}} />
           </a>
             {linkOpen && <Modal initiallyOpen onClose={() => setLinkOpen(false)}>
               <div style={{background: 'white', padding: 20, boxSizing: 'border-box', display: 'flex', flexFlow: 'column nowrap'}}>
                   <h1>Logo Link</h1>
                   <input placeholder="https://" value={image.sic_link} onChange={saveLink} style={{width: 200, height: 44, border: '1px solid black'}} />
                   <div>This value is autosaved.</div>
               </div>
             </Modal>}
       </Deleteable>
    );
};

const _distance = (targetX, targetY, {x, y, width, height}) => {
    let corners = [[x, y], [x, y + height], [x + width, y], [x + width, y + width]];
    let ret = Infinity;
    for (const [x, y] of corners) {
        let d = Math.sqrt((x - targetX) * (x - targetX)
                        + (y - targetY) * (y - targetY));
        if (d < ret) {
            ret = d;
        }
    }
    return ret;
};

function findNearest(x, y, className) {
    let target = document.elementFromPoint(x, y);

    // first, we try children

    let ret = null;
    let dist = Infinity;

    const test = c => {
        if (!c || !c.getBoundingClientRect || !c.classList) return;

        if (c.classList.contains(className)) {
            let d = _distance(x, y, c.getBoundingClientRect());
            if (d < dist) {
                dist = d;
                ret = c;
            }
        }
    };

    const walkChildren = n => {
        for (let c of Array.from(n.children)) {
            test(c);
            walkChildren(c);
        }
    };

    walkChildren(target);

    // Then we try ancestors

    let n = target;
    while (n) {
        test(n);
        n = n.parentNode;
    }

    return ret;
}

export const MultipleMediaControl = ({state: images, setState: setImages}) => {
    const {BaseMediaPicker:{openMediaPicker: openPicker}} = polyphony.components.backend;
    const addImages = imgs => setImages(images.concat(imgs));

    const moveImage = (from, to) => {
        let tmp = images[from];
        images[from] = null;
        let after = images.slice(to);
        let before = images.slice(0, to);
        images = [...before, tmp, ...after];
        images = images.filter(x => x !== null);
        setImages(images);
    };

    // TODO: animate sliding shit around!

    const [{}, dropTarget] = useDropTarget({
        type: 'sic/footer-logos',
        onDrop: ({index}, x, y) => {
            let target = findNearest(x, y, 'draggable-image');

            const {x:tx, width} = target.getBoundingClientRect();

            let isLeftSide = x - (tx + width / 2) <= 0;
            let targetIdx = parseInt(target.dataset.index);

            moveImage(index, isLeftSide ? targetIdx : targetIdx + 1);
        }
    });

    const [{hover}, ref] = useHover();

    return (
        <div>
            <div ref={dropTarget} style={{display: 'flex', flexFlow: 'row wrap'}}>
                {images.map((img, idx) => <MMImage key={`${img.id} ${idx}`} index={idx} image={img} images={images} setImages={setImages}/>)}
            </div>
            <div ref={ref} style={{cursor: 'pointer', color: hover ? 'black' : undefined}} onClick={() => openPicker(null, addImages, ['image'], true)}>+ Image</div>
        </div>
    );
};

MultipleMediaControl.defaultState = [];

